export default class FormGroupPassword {

    constructor($view) {
        this.view = $view;
        this.$input = $view.find('.form-control');
        this.$togglePassword = $view.find('.toggle-password');
        this.$password = $view.find('.js-password');
        this.$passwordConfirm = $view.find('.js-password-confirm');

        this.$nbChar = $view.find('.js-nb-char');
        this.$majChar = $view.find('.js-maj-char');
        this.$minChar = $view.find('.js-min-char');
        this.$specialChar = $view.find('.js-special-char');

        this.$majCharRegEx = new RegExp('([A-Z])');
        this.$minCharRegEx = new RegExp('([a-z])');
        this.$specialCharRegEx = new RegExp('[^0-9a-zA-Z\\s\]');

        this.$confirm = $view.find('.js-password-confirm');
        this.$group = $view.find('.js-group');
        this.$regExPwd = new RegExp('(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}');

        this.bind();
    }

    bind() {
        this.togglePassword();
        this.showPasswordRequirements();
    }

    showPasswordRequirements() {
        this.$password.on('keyup', (e) => {
            this.checkPasswordLength();
            this.checkPasswordMinChar();
            this.checkPasswordMajChar();
            this.checkPasswordSpecialChar();
        });

        this.$confirm.on('keyup', (e) => {
            this.checkPasswordEquality();
        })
    }

    togglePassword() {
        this.$togglePassword.on('click', (e) => {
            const target = e.currentTarget.dataset.target;
            const input = target === 'first' ? this.$password : this.$passwordConfirm;
            const icon = target === 'first' ? $('a[data-target="first"]').find('i') : $('a[data-target="second"]').find('i');

            if (input.attr('type') === "password") {
                input.attr('type', 'text');
            } else {
                input.attr('type', 'password');
            }

            icon.toggleClass("fsi-password-see");
            icon.toggleClass("fsi-password-hide");

            e.preventDefault();
        });
    }

    checkPasswordLength() {
        if (this.$password.val().length >= 8) {
            this.setValid(this.$nbChar);
        } else {
            this.setInvalid(this.$nbChar);
        }
    }

    checkPasswordMinChar() {
        if (this.$majCharRegEx.test(this.$password.val())) {
            this.setValid(this.$majChar);
        } else {
            this.setInvalid(this.$majChar);
        }
    }

    checkPasswordMajChar() {
        if (this.$minCharRegEx.test(this.$password.val())) {
            this.setValid(this.$minChar);
        } else {
            this.setInvalid(this.$minChar);
        }
    }

    checkPasswordSpecialChar() {
        if (this.$specialCharRegEx.test(this.$password.val())) {
            this.setValid(this.$specialChar);
        } else {
            this.setInvalid(this.$specialChar);
        }
    }

    setValid(element) {
        element.removeClass('invalid');
        element.addClass('valid');
    }

    setInvalid(element) {
        element.removeClass('valid');
        element.addClass('invalid');
    }

    setIsValid(element) {
        element.removeClass('is-invalid');
        element.addClass('is-valid');
    }

    setIsInvalid(element) {
        element.removeClass('is-valid');
        element.addClass('is-invalid');
    }

    checkPasswordEquality()
    {
        if (this.$confirm.val() === this.$password.val() &&
            this.$confirm.val() !== '' &&
            this.$regExPwd.test(this.$confirm.val())
        ) {
            this.setIsValid(this.$group);
            this.setIsValid(this.$confirm);
        } else {
            this.setIsInvalid(this.$group);
            this.setIsInvalid(this.$confirm);
        }

        return false;
    }
}

